export default "__VITE_ASSET__BTjmimMc__"